/**
 * Extracts the first name from a display name string.
 *
 * Handles common formats from Microsoft Entra ID:
 * - "LastName, FirstName" (e.g., "Smith, Luke") → "Luke"
 * - "FirstName LastName" (e.g., "Nikola Bisercic") → "Nikola"
 * - "FirstName" (e.g., "Luke") → "Luke"
 *
 * Returns empty string if the name cannot be parsed.
 */
export function parseFirstName(name?: string): string {
  if (!name) return "";

  const trimmed = name.trim();
  if (!trimmed) return "";

  // "LastName, FirstName" format — split on comma, take second part
  if (trimmed.includes(",")) {
    const afterComma = trimmed.split(",")[1]?.trim();
    if (afterComma) {
      // Take only the first word after the comma (handles "LastName, FirstName MiddleName")
      return afterComma.split(/\s+/)[0];
    }
  }

  // "FirstName LastName" or just "FirstName" — take the first word
  // Strip any trailing commas (e.g., malformed "Smith," falls through here)
  return trimmed.split(/\s+/)[0].replace(/,$/, "");
}
